import React from 'react'
import { Image } from 'react-native'
import { styles } from './styles'
import logo from './logo.png'

export const LogoChoice = () => <Image resizeMode="contain" style={styles.image} source={{uri:logo}} />
